// extracted by mini-css-extract-plugin
export default {"footer":"footer_footer__XXj-R","footerLinks":"footer_footerLinks__DLsY7"};